import React, { Component } from 'react';

//componentes
import PrimerTrimestre from './primerTrimestre'

class Index extends Component {

    render(){
        return(
            <div>
                <PrimerTrimestre />
            </div>
        );
    }

}
export default Index;